module.exports = __webpack_public_path__ + "static/media/1.9a20a9c8.jpg";